import { combineEpics } from 'redux-observable';

import providerSurgeIncentiveEpics from './provider-surge-incentive-epics';
import providerSurgeIncentiveFormEpics from './provider-surge-incentive-form-epics';
import providerSurgeIncentiveRequestEpics from './provider-surge-incentive-request-epics';

export default combineEpics(
  providerSurgeIncentiveEpics,
  providerSurgeIncentiveFormEpics,
  providerSurgeIncentiveRequestEpics
);
